<kilowant-header title="Our Story" [isBuyer]="(user==null)?false:true" [isHome]="(user==null)?true:false" [linkHome]="(user==null)?'/':'/user/home'"></kilowant-header>
<div class="wrapper-main-public-area">
    <div class="form mt-20">
        <div class="about-photo"></div>
        <p>
            Kilowant's founder James Grasso started his career in the retail energy industry over 30 years ago. In 2000 he founded SilentSherpa, a leader in energy market guidance solutions for commercial consumers. James has an established reputation as a market expert and consumer advocate.
        </p>
        <p>
            Throughout his career,  James saw firsthand the many challenges consumers faced in reducing their energy supply cost ... most notably how to exploit the rewards of low cost deregulated energy supply, while mitigating the risks associated with market timing, contract term, and nontransparent transactions.  While available to large commercial consumers, his services were unaffordable for the small business and residential consumer.
        </p>
        <p>
            With the commercialization of AI in the early 2020's, James saw an opportunity to transfer three decades of market expertise into an application that could democratize his knowledge to benefit all consumers.  With the help of his senior application developer, the pair set out to create the first AI agent for retail energy purchasing.  In 2022, kilowant was born and launched in James' home state of Rhode Island fully automating the energy shopping experience from search to source.
        </p>
        <p>
            Today, Kilowant is a one-of-a-kind, trusted tool in select markets for consumers who want to save on their electric bills, but want to avoid the all too common "learned by getting burned" model. We will steadily be expanding into new markets, with the ultimate goal of making our service available in every state where consumer energy choice is allowed. By broadening our reach, we aim to ensure that more consumers can benefit from a much simpler, more transparent, and safer way of buying energy supply.
        </p>
    </div>
</div>
<div class="footer-bottom-fixed-full-width">
    <div class="wrapperMain">
        <div class="bottom-selector" [class]="(ourTeamOpened)?'extended':''">
            <span class="title" (click)="ourTeamOpen()">Our Team</span>
            <div class="footer-basement" [style.height]="(!ourTeamOpened)?'0':'auto'">
                <div class="grey-text footer-scroll">
                    <ul class="team">
                        <li class="i-team1">
                            <b>James Grasso</b><br />
                            President &amp; Founder
                        </li>
                        <li class="i-team2">
                            <b>Sergey Samartsev</b><br />
                            Application Development
                            Manager
                        </li>
                        <li class="i-team3">
                            <b>Rocco Grasso</b><br />
                            Channel Development
                            Manager
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>